
<div class="container" style="margin-top:80px;">
	<div class="row">
		<div class="col-md-6 col-md-offset-3">
			<profile-edit-form [model]="model | async" (onSave)="saveUser($event)" (onCancel)="cancel()"></profile-edit-form>
		</div>
	</div>
</div>

